import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  /***
   * # Bulk Action Controller
   *
   *  ## API
   *
   *  __Targets__
   *    * checkbox - the value of the checkbox (e.g. the id of an asset) will be passed to the action.
   *    * actionLink - link to a bulk action. will be updated to contain all checked values.
   *    * actionList - show this if at least one checkbox is checked. - if this is set, hideClass needs to be set.
   *
   *  __Classes__
   *    * hide - applied and removed to `actionList` target if something is selected
   */
  static classes = ["hide"];
  static targets = ["actionList", "checkbox", "actionLink", "selectionCount"];

  initialize() {
    this.idList = [];
  }

  checkboxTargetConnected(checkboxElement) {
    this.updateIdList(checkboxElement);
    checkboxElement.addEventListener("change", (event) => {
      this.updateIdList(event.target);
    });
  }

  updateIdList(checkboxElement) {
    const id = checkboxElement.value;
    if (!checkboxElement.checked) {
      this.idList = this.idList.filter((some_id) => some_id !== id);
    } else if (!this.idList.includes(id)) {
      this.idList.push(id);
    }
    this.updateLinksAndVisibility();
  }

  updateLinksAndVisibility() {
    const idListStr = this.idList.join(",");
    this.actionLinkTargets.forEach((anchor) => {
      const url = new URL(anchor.href);
      url.searchParams.set("id_list", idListStr);
      anchor.href = url.href;
    });

    const itemCount = this.idList.length;
    this.actionListTargets.forEach((list) => {
      list.classList.toggle(this.hideClass, itemCount === 0);
    });
    this.selectionCountTargets.forEach((countElem) => {
      countElem.innerText = itemCount;
    });
  }

  resetSelection() {
    this.checkboxTargets.forEach((checkboxElement) => {
      checkboxElement.checked = false;
    });
    this.idList = [];
    this.updateLinksAndVisibility();
  }

  setAllCheckboxes() {
    this.checkboxTargets.forEach((checkboxElement) => {
      checkboxElement.checked = true;
      this.updateIdList(checkboxElement);
    });
  }
}
